import { createAction, props } from '@ngrx/store';
import { ProjectGroup } from 'cargo-chief-commons';

export const PROJECT_GROUPS = {
	OPEN_DIALOG: createAction('[Project details] Open create project group dialog', props<any>()),
	CLOSE_DIALOG: createAction('[Project details] Close project group dialog', props<any>()),
	CREATE: createAction('[Project details] Create project group', props<any>()),
	CREATE_SUCCESS: createAction('[Project details] Create project group success', props<any>()),
	CREATE_FAILURE: createAction(
		'[Project details] Create project group failure',
		props<{ payload: { message: string } }>()
	),

	MOVE_GROUPS: createAction('[Project details] Move project Groups', props<any>()),
	MOVE_GROUPS_SUCCESS: createAction('[Project details] Move project Groups success', props<any>()),
	MOVE_GROUPS_FAILURE: createAction(
		'[Project details] Move project Groups failure',
		props<{ payload: { message: string } }>()
	),

	DELETE: createAction('[Project details] Delete project groups', props<any>()),
	DELETE_SUCCESS: createAction('[Project details] Delete project groups success', props<any>()),
	DELETE_FAILURE: createAction(
		'[Project details] Delete project groups failure',
		props<{ payload: { message: string } }>()
	),

	UPDATE: createAction('[Project details] Update project groups', props<any>()),
	UPDATE_SUCCESS: createAction('[Project details] Update project groups success', props<any>()),
	UPDATE_FAILURE: createAction(
		'[Project details] Update project groups failure',
		props<{ payload: { message: string } }>()
	),

	DELETE_CARRIER: createAction(
		'[Project details] Delete carrier from project groups',
		props<any>()
	),
	DELETE_CARRIER_SUCCESS: createAction(
		'[Project details] Delete carrier from project groups success',
		props<any>()
	),
	DELETE_CARRIER_FAILURE: createAction(
		'[Project details] Delete carrier from project groups failure',
		props<{ payload: { message: string } }>()
	),

	SET: {
		PROJECT_GROUPS: createAction(
			'[Project details] Set project groups',
			props<{ list: ProjectGroup[] }>()
		),
	},

	GROUP_AND_DEFAULT_GROUP: {
		CREATE: createAction('[Project details] Create project group and system group', props<any>()),
		SUCCESS: createAction(
			'[Project details] Create project group and system group success',
			props<any>()
		),
		FAILURE: createAction(
			'[Project details] Create project group and system group failure',
			props<any>()
		),
	},

	ADD_TO_GROUP: {
		ADD: createAction('[Project details] Add carriers to another group', props<any>()),
		SUCCESS: createAction('[Project details] Add carriers to another group success', props<any>()),
		FAILURE: createAction('[Project details] Add carriers to another group failure', props<any>()),
	},

	UPDATE_GROUP: {
		UPDATE: createAction('[Project details] Update project group name, delay', props<any>()),
		SUCCESS: createAction(
			'[Project details] Update project group name, delay success',
			props<any>()
		),
		FAILURE: createAction(
			'[Project details] Update project group name, delay failure',
			props<any>()
		),
		CANCEL: createAction(
			'[Project details] Update project group name, delay close dialog',
			props<any>()
		),
	},
};
